import * as React from "react";
const SvgSheetLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 69, height: 4, viewBox: "0 0 69 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.25 2H66.75", stroke: "#E8F1F8", strokeWidth: 3, strokeLinecap: "round" }));
export default SvgSheetLine;
